/*  JS of Push Promotion Section 
    Added by Wilson from Galadrim  */

function setupPushPromotionQuantityAndCart() {
  const pushPromotion = document.querySelector(".push-promotion");
  if (!pushPromotion) return;

  pushPromotion.addEventListener("click", function (e) {
    // Quantity plus/minus
    if (e.target.closest(".qty-btn")) {
      const btn = e.target.closest(".qty-btn");
      const input = btn.closest(".quantity-selector").querySelector(".qty-input");
      const min = parseInt(input.getAttribute("min")) || 1;
      const current = parseInt(input.value) || min;
      if (btn.querySelector('img[alt="-"]')) {
        input.value = Math.max(min, current - 1);
      } else if (btn.querySelector('img[alt="+"]')) {
        input.value = current + 1;
      }
      e.preventDefault();
    }

    // Add to cart
    if (e.target.closest(".productitem--action-atc")) {
      const btn = e.target.closest(".productitem--action-atc");
      const card = btn.closest(".productgrid--item");
      const input = card.querySelector(".qty-input");
      const variantId = btn.getAttribute("data-variant-id");
      const quantity = parseInt(input.value) || 1;

      btn.disabled = true;
      btn.classList.add("processing");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      })
        .then(response => response.json())
        .then(data => {
          btn.disabled = false;
          btn.classList.remove("processing");
          btn.classList.add("added-success");
          setTimeout(() => {
            btn.classList.remove("added-success");
          }, 900);
          if (typeof window.showSuccessToast === "function") {
            window.showSuccessToast();
          }
          window.refreshCartDrawerSection();
          if (
            document.body.classList.contains("template-cart") &&
            typeof window.refreshCartPageSection === "function"
          ) {
            window.refreshCartPageSection();
          }
        })
        .catch(error => {
          btn.disabled = false;
          btn.classList.remove("processing");
        });

      e.preventDefault();
    }
  });
}

document.addEventListener("DOMContentLoaded", setupPushPromotionQuantityAndCart);
document.addEventListener("shopify:section:load", setupPushPromotionQuantityAndCart);
